import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEthereum: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconEthereum"><Path d="M10.0761 13.5796L12 16.2249L13.9239 13.5796L12 14.301L10.0761 13.5796Z" fill="currentColor"/><Path d="M12 12.699L14.8136 11.6439L12 7.77514L9.18636 11.6439L12 12.699Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM12 5.22486L7.07263 12L12 18.7751L16.9274 12L12 5.22486Z" fill="currentColor"/></CentralIconBase>;
});

export default IconEthereum;
